import React from 'react';
import PropTypes from 'prop-types';
import loadImage from 'blueimp-load-image';

import {
  Circle,
  CloseIcon,
  ImageContainer,
  RemoveBtn,
  PhotoIcon,
  PhotosWrapper,
  Plus,
  Title,
  Wrapper,
  SectionTitle,
  DateSubtitle,
  Header,
  HeaderTitle,
  CancelBtn,
} from './PhotoWidget.style';

import icon from '../../../../assets/images/photo-icon.png';

import { dataUrlToBinary, getImageSize } from '../../../../utils';

class PhotoWidget extends React.Component {
  static handleClickBeforeCircle() {
    const input = document.querySelector('#beforeInput');
    input.click();
  }

  static handleClickAfterCircle() {
    const input = document.querySelector('#afterInput');
    input.click();
  }

  static propTypes = {
    beforeImages: PropTypes.arrayOf(PropTypes.shape({ arrayBuffer: PropTypes.arrayBuffer, dataUri: PropTypes.string }))
      .isRequired,
    afterImages: PropTypes.arrayOf(PropTypes.shape({ arrayBuffer: PropTypes.arrayBuffer, dataUri: PropTypes.string }))
      .isRequired,
    updateBeforeImages: PropTypes.func.isRequired,
    updateAfterImages: PropTypes.func.isRequired,
    removeBeforeImages: PropTypes.func.isRequired,
    removeAfterImages: PropTypes.func.isRequired,
    onShowCancelModal: PropTypes.func.isRequired,
    copy: PropTypes.shape({}).isRequired,
  };

  fileReaderWithPromise = (file, type) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = e => resolve(e.target.result);
      reader.onerror = err => reject(err);
      reader[type](file);
    });

  handleBeforeUpload = event => {
    const { updateBeforeImages } = this.props;
    const file = event.target.files[0];

    getImageSize(file, (width, height) => {
      loadImage.parseMetaData(file, data => {
        let orientation = 0;
        if (data.exif) {
          orientation = data.exif.get('Orientation');
        }
        loadImage(
          file,
          canvas => {
            const base64Data = canvas.toDataURL(file.type);
            updateBeforeImages({
              dataUri: base64Data,
              arrayBuffer: dataUrlToBinary(base64Data, width * height),
            });
          },
          {
            canvas: true,
            orientation,
            maxWidth: 400,
          }
        );
      });
    });
  };

  handleAfterUpload = event => {
    const { updateAfterImages } = this.props;
    const file = event.target.files[0];

    getImageSize(file, (width, height) => {
      loadImage.parseMetaData(file, data => {
        let orientation = 0;
        if (data.exif) {
          orientation = data.exif.get('Orientation');
        }
        loadImage(
          file,
          canvas => {
            const base64Data = canvas.toDataURL(file.type);
            updateAfterImages({ dataUri: base64Data, arrayBuffer: dataUrlToBinary(base64Data, width * height) });
          },
          {
            canvas: true,
            orientation,
            maxWidth: 400,
          }
        );
      });
    });
  };

  deleteBeforeImage = imageNr => () => {
    const { removeBeforeImages } = this.props;
    removeBeforeImages(imageNr);
  };

  deleteAfterImage = imageNr => () => {
    const { removeAfterImages } = this.props;
    removeAfterImages(imageNr);
  };

  render() {
    const { beforeImages, afterImages, copy, onShowCancelModal } = this.props;
    const currentDate = new Date();
    return (
      <Wrapper>
        <input
          style={{ display: 'none' }}
          id="beforeInput"
          type="file"
          name="file"
          accept="image/*"
          multiple="true"
          onChange={this.handleBeforeUpload}
        />
        <input
          style={{ display: 'none' }}
          id="afterInput"
          type="file"
          name="file"
          accept="image/*"
          multiple="false"
          onChange={this.handleAfterUpload}
        />
        {/* <button style={{ color: "white" }} onClick={this.handleOnclick}>Hello</button> */}
        <Header>
          <HeaderTitle>
            <DateSubtitle>{`${currentDate.getDate()}/${currentDate.getMonth() +
              1}/${currentDate.getFullYear()}`}</DateSubtitle>
            <SectionTitle>{copy.photo}</SectionTitle>
          </HeaderTitle>
          {/* New Visit 画面の[X]ボタン (押下後、キャンセル確認モーダルが表示される) */}
          <CancelBtn onClick={onShowCancelModal}>
            <CloseIcon />
          </CancelBtn>
        </Header>

        <Title>{copy.before}</Title>
        <PhotosWrapper>
          <Circle active onClick={beforeImages.length < 1 ? this.constructor.handleClickBeforeCircle : null}>
            {beforeImages && beforeImages[0] ? (                                        // eslint-disable-line
              <ImageContainer image={beforeImages ? beforeImages[0].dataUri : null} />  // eslint-disable-line
            ) : (                                                                       // eslint-disable-line
                beforeImages.length === 0 ? <PhotoIcon src={icon} /> : <Plus>+</Plus>   // eslint-disable-line
              )                                                                         // eslint-disable-line
            }
            {beforeImages &&
              beforeImages[0] && (
                <RemoveBtn onClick={this.deleteBeforeImage(0)}>
                  <CloseIcon />
                </RemoveBtn>
              )}
          </Circle>
          <Circle
            active={beforeImages.length >= 1}
            onClick={beforeImages.length < 2 ? this.constructor.handleClickBeforeCircle : null}
          >
            {beforeImages && beforeImages[1] ? (                                        // eslint-disable-line
              <ImageContainer image={beforeImages ? beforeImages[1].dataUri : null} />  // eslint-disable-line
            ) : (                                                                       // eslint-disable-line
                beforeImages.length === 1 ? <PhotoIcon src={icon} /> : <Plus>+</Plus>   // eslint-disable-line
              )                                                                         // eslint-disable-line
            }
            {beforeImages &&
              beforeImages[1] && (
                <RemoveBtn onClick={this.deleteBeforeImage(1)}>
                  <CloseIcon />
                </RemoveBtn>
              )}
          </Circle>
          <Circle
            active={beforeImages.length >= 2}
            onClick={beforeImages.length < 3 ? this.constructor.handleClickBeforeCircle : null}
          >
            {beforeImages && beforeImages[2] ? (                                        // eslint-disable-line
              <ImageContainer image={beforeImages ? beforeImages[2].dataUri : null} />  // eslint-disable-line
            ) : (                                                                       // eslint-disable-line
                beforeImages.length === 2 ? <PhotoIcon src={icon} /> : <Plus>+</Plus>   // eslint-disable-line
              )                                                                         // eslint-disable-line
            }
            {beforeImages &&
              beforeImages[2] && (
                <RemoveBtn onClick={this.deleteBeforeImage(2)}>
                  <CloseIcon />
                </RemoveBtn>
              )}
          </Circle>
        </PhotosWrapper>

        <Title>{copy.after}</Title>
        <PhotosWrapper>
          <Circle active onClick={afterImages.length < 1 ? this.constructor.handleClickAfterCircle : null}>
            {afterImages && afterImages[0] ? (                                        // eslint-disable-line
              <ImageContainer image={afterImages ? afterImages[0].dataUri : null} />  // eslint-disable-line
            ) : (                                                                     // eslint-disable-line
                afterImages.length === 0 ? <PhotoIcon src={icon} /> : <Plus>+</Plus>  // eslint-disable-line
              )                                                                       // eslint-disable-line
            }
            {afterImages &&
              afterImages[0] && (
                <RemoveBtn onClick={this.deleteAfterImage(0)}>
                  <CloseIcon />
                </RemoveBtn>
              )}
          </Circle>
          <Circle
            active={afterImages.length >= 1}
            onClick={afterImages.length < 2 ? this.constructor.handleClickAfterCircle : null}
          >
            {afterImages && afterImages[1] ? (                                        // eslint-disable-line
              <ImageContainer image={afterImages ? afterImages[1].dataUri : null} />  // eslint-disable-line
            ) : (                                                                     // eslint-disable-line
                afterImages.length === 1 ? <PhotoIcon src={icon} /> : <Plus>+</Plus>  // eslint-disable-line
              )                                                                       // eslint-disable-line
            }
            {afterImages &&
              afterImages[1] && (
                <RemoveBtn onClick={this.deleteAfterImage(1)}>
                  <CloseIcon />
                </RemoveBtn>
              )}
          </Circle>
          <Circle
            active={afterImages.length >= 2}
            onClick={afterImages.length < 3 ? this.constructor.handleClickAfterCircle : null}
          >
            {afterImages && afterImages[2] ? (                                        // eslint-disable-line
              <ImageContainer image={afterImages ? afterImages[2].dataUri : null} />  // eslint-disable-line
            ) : (                                                                     // eslint-disable-line
                afterImages.length === 2 ? <PhotoIcon src={icon} /> : <Plus>+</Plus>  // eslint-disable-line
              )                                                                       // eslint-disable-line
            }
            {afterImages &&
              afterImages[2] && (
                <RemoveBtn onClick={this.deleteAfterImage(2)}>
                  <CloseIcon />
                </RemoveBtn>
              )}
          </Circle>
        </PhotosWrapper>
      </Wrapper>
    );
  }
}

export default PhotoWidget;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/PhotoWidget/PhotoWidget.js